import { Stack, styled } from '@mui/material';

const StyledStackHeader = styled(Stack)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  background: theme.palette.background.primary,
  zIndex: 1,
  borderRadius: theme.shape.borderRadius * 5,
}));

export default StyledStackHeader;
